<script setup lang="ts">
import CourseNoticeItem from "components/course/detail/CourseNoticeItem.vue";
import {Notice} from "@/types";

defineProps<{
  noticeList: Notice[]
}>()

const emit = defineEmits(["onEdit", "onDelete"])

const onEdit = (id: number) => {
  emit("onEdit", id);
}

const onDelete = (id: number) => {
  emit("onDelete", id);
}
</script>

<template>
  <div class="bg-white rounded-md py-1.5rem px-2rem shadow-md">
    <div class="text-[rgba(0,0,0,0.85)] text-1.25em font-bold">公告</div>
    <div class="flex flex-wrap" v-if="noticeList" >
      <course-notice-item v-for="notice in noticeList" :notice="notice" @on-edit="onEdit" @on-delete="onDelete">
      </course-notice-item>
    </div>
    <div v-if="!noticeList || noticeList.length === 0" class="mt-1rem">
      暂无公告~
    </div>
  </div>
</template>

<style scoped>

</style>